import { useState } from "react";
import { SectionLabel, Reveal, NC } from "./shared";
import { AccordionItem } from "./Accordion";

const FAQS = [
  ["Is the masterclass free?", "Yes. Free to attend, no fee, nothing to buy on the class."],
  ["Is this a loan application?", "No. Attending is not an application, an approval, or a commitment to lend."],
  ["Will attending affect my credit?", "No. No credit pull is required to attend the class."],
  ["Who is this masterclass for?", "People planning a home purchase with VA-backed financing in Florida or Pennsylvania, including households with remaining entitlement, an existing VA-financed home, a move-up plan, or a prior \u201Cno\u201D they never got explained."],
  ["What will be covered?", "The five modules above: clarifying what you're working with, seeing the whole transaction, remaining entitlement and move-up considerations, where buyers get derailed, and choosing your responsible next step. General education only — not individualized advice."],
  ["Is it live or on demand?", null],
  ["What happens after I register?", "You get a confirmation with the join link and reminders. After the class, if you want personalized options, you can complete a mortgage application and required authorizations to request a one-on-one Better Deal Review™."],
  ["Do I have to speak with a loan officer?", "No. Attending is education. The application and the Better Deal Review™ are entirely optional and only happen if you choose them."],
];

export default function FAQ() {
  const [open, setOpen] = useState(-1);
  return (
    <section id="faq" className="py-24 lg:py-36 px-6 lg:px-10" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <SectionLabel n="008" text="BEFORE YOU ASK" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-12">COMMON QUESTIONS</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border-t border-[#404653]/40">
            {FAQS.map(([q, a], i) => (
              <AccordionItem
                key={i}
                num={String(i + 1).padStart(2, "0")}
                title={q}
                body={
                  a || (
                    <>
                      It's a live session with live Q&amp;A. Registrants are notified about replay availability if a
                      replay is offered. <NC label="REPLAY POLICY" />
                    </>
                  )
                }
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
                testId={`faq-item-${i + 1}`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
